<div
    *transloco="let tAddFieldContent; read: 'manage_fields.add_field_content'"
    class="flex flex-col w-full gap-4"
>
    <div class="flex gap-4 w-full">
        <app-color-picker
            class="sm:w-[45%] max-sm:w-full"
            [set]="SetType.RATING"
            [color]="settings.color"
            [name]="tAddFieldContent('rating_color')"
            [subtitle]="tAddFieldContent('rating_color_subtitle', { name: field().name })"
            (colorChange)="updateColor($event)"
        ></app-color-picker>
        <app-icon-picker
            class="sm:w-[45%] max-sm:w-full"
            [set]="SetType.RATING"
            [icon]="settings.icon"
            [iconColor]="settings.color"
            [subtitle]="tAddFieldContent('rating_icon_subtitle', { name: field().name })"
            [name]="tAddFieldContent('rating_icon')"
            (iconChange)="updateIcon($event)"
        ></app-icon-picker>
    </div>
    <div class="flex gap-4 w-full">
        <app-tb-select
            class="flex flex-col sm:w-[45%] max-sm:w-full"
            [label]="tAddFieldContent('rating_label')"
            [value]="settings.count"
            (selectionChange)="updateCount($event)"
        >
            @for (count of countArray; track count) {
                <app-tb-option [value]="count"> {{ count }} </app-tb-option>
            }
        </app-tb-select>
        <div class="flex flex-col gap-3 sm:w-[45%] max-sm:w-full h-full">
            <label class="body-1 block"> {{ tAddFieldContent('rating_preview') }} </label>
            <div class="flex gap-1 w-full">
                @for (preview of previewCountArray; track preview) {
                    <app-tb-icon
                        class="icon-m"
                        [icon]="settings.icon"
                        [filled]="true"
                        [style.color]="settings.color"
                    ></app-tb-icon>
                }
            </div>
        </div>
    </div>
</div>
